import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
//import artistStyles from "views/Artists/Styles/ArtistStyles.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";
//Images
import DonBendel from "assets/img/Bendel/donaldbendel.jpg";
import Bowl from "assets/img/Bendel/largebendelclassicbowl14h.jpg";
import Phone from "assets/img/Bendel/largebendelphone68h.jpg";
import BentPlatter from "assets/img/Bendel/largebentplatterbendel.jpg";

class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false
    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
                  <div>
                    <img
                      src={DonBendel}
                      alt="Don Bendel"
                      className="slick-image"                    
                      
                    />
                  </div>
                  <div>
                    <img
                      src={Bowl}
                      alt= "Bendel Classic Bowl"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={Phone}
                      alt="Bendel Phone"
                      className="slick-image"
                    />
                  </div>
                  <div>
                    <img
                      src={BentPlatter}
                      alt="Bendel Bent Platter"
                      className="slick-image"
                    />
                  </div>                  
                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/Artists/Sections/DonBendelCarousel.jsx